import React from 'react'
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    secondaryRoot:{
        display: 'flex',
        flex:1,
        flexDirection: 'column',
        // background:'red',
        height: '100%'
    },
    flexChild: {
        flex: 1,
        // background:'green',
        paddingTop: 64,
    },
    // header:{
    //     flex: 1,
    //     background:'yellow',
    // }
}))
const NoLayout= props => {
    const {children}= props
    const classes = useStyles()

    return (
        <div className={classes.secondaryRoot}>
           
            {/* <div className={classes.flexChild}> */}
                    {children}
            {/* </div> */}
           
        </div>
    )
}

export default NoLayout
NoLayout.propTypes = {
    children: PropTypes.node
}